import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { AboutUsEmployees, AboutUsJobOfferContent, AboutUsPageContent, AboutUsTeaser } from '../../api/api-types';

export const actions = createActionGroup({
    source: 'about us',
    events: {
        'Load About Us Content': emptyProps(),
        'Load About Us Content Success': props<{ content: AboutUsPageContent }>(),
        'Load About Us Content Failure': props<{ error: string }>(),

        'Load About Us below the fold content': emptyProps(),

        'Load About Us Teaser': emptyProps(),
        'Load About Us Teaser Success': props<{ teasers: AboutUsTeaser[] }>(),
        'Load About Us Teaser Failure': props<{ error: string }>(),

        'Load Job offer content': emptyProps(),
        'Load Job offer content Success': props<{ jobOfferContent: AboutUsJobOfferContent }>(),
        'Load Job offer content Failure': props<{ error: string }>(),

        'Load Employees': emptyProps(),
        'Load Employees Success': props<{ employees: AboutUsEmployees }>(),
        'Load Employees Failure': props<{ error: string }>(),
    },
});
